module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/photo_4@2x-db2a7182385ae4e8a47728e3264d7ab0.jpg";